import { api } from "../../Services";

export const downloadExcel = async () => {
  const response = await api.get("/listing-assets/download", {
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "listing-assets.xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();
};
